import { PUT_STAFF_START } from '../../types';

export const put_staff = (payload) => ({
  type: PUT_STAFF_START,
  payload,
});
